import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createClient = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_CLIENT, payload);
  return response;
};

const updateClient = (payload: any) => {
  const response: Promise<any> = api.create(url.UPDATE_CLIENT, payload);
  return response;
};

const getClient = (params: { clientId: string | undefined }) => {
  const response: Promise<any> = api.get(url.GET_CLIENT, params);
  return response;
};

const getAllClients = () => {
  const response: Promise<any> = api.get(url.GET_ALL_CLIENTS);
  return response;
};

const deleteClient = (params: { clientId: string | undefined }) => {
  const response: Promise<any> = api.delete(url.DELETE_CLIENT, params);
  return response;
};

const deleteSelectedClients = (params: any) => {
  const response: Promise<any> = api.update(url.DELETE_CLIENTS, params);
  return response;
};

export {
  createClient,
  updateClient,
  getClient,
  getAllClients,
  deleteClient,
  deleteSelectedClients,
};
